import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-wait-for-proServe-project-import-popup',
  templateUrl: './wait-for-proServe-project-import-popup.component.html'
})
export class WaitForProServeProjectImportPopupComponent {
}
